import { Plugin, App } from 'vue';

export default {
  install(app: App) {
    app.config.globalProperties.$resolve = (relativePath: string) => {
      if (!relativePath && relativePath !== '') {
        // Allows empty string
        throw new Error(`Argument 'relativePath' is required`);
      }
      if (relativePath.startsWith('.') || relativePath.indexOf('../') > -1) {
        // No `./` or `../` syntax
        throw new Error(`Argument 'relativePath' cannot use relative pathing`);
      }
      let localRelativePath = relativePath;
      if (!localRelativePath.startsWith('/')) {
        localRelativePath = `/${localRelativePath}`;
      }
      return `${window.location.origin}${localRelativePath}`;
    };
  },
} as Plugin;
